import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  Section,
  SectionContent,
  WhyPlayfair,
  WhyItem,
  WhyIcon,
  WhyTitle,
  WhyText,
} from '../styles/sections';
import {
  SplitHeroSection,
  SplitHeroGrid,
  SplitHeroTextCol,
  SplitHeroMediaCol,
  SplitHeroMedia,
  FloatingBadge,
  FloatingBadgeNumber,
  FloatingBadgeLabel,
} from '../styles/mediaHero';
import {
  StatsRow,
  StatItem,
  StatNumber,
  StatLabel,
  PullQuoteWrap,
  PullQuoteMark,
  PullQuoteText,
  PullQuoteAuthor,
} from '../styles/about';

const stats = [
  { number: '200+', label: 'Clubs' },
  { number: '2,000+', label: 'Members' },
  { number: '3,000+', label: 'Fines Tracked' },
];

const values = [
  {
    emoji: '⚽',
    title: 'Our Mission',
    text: 'To take the awkwardness out of team fines, so clubs can focus on the game, notthe admin.',
  },
  {
    emoji: '🤝',
    title: 'Fair By Design',
    text: 'Every club sets its own rules — Playfair just makes them easy to follow and enforce.',
  },
  {
    emoji: '💚',
    title: 'Built With Clubs',
    text: 'Every feature started as feedback from a real committee, captain, or club treasurer.',
  },
];

function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About Us | Playfair</title>
        <meta name="description" content="Playfair started with a simple idea: managing team fines shouldn't be harder than managing the team itself." />
        <link rel="canonical" href="https://playfair.online/about" />
      </Helmet>

      <SplitHeroSection bg="#fff">
        <SplitHeroGrid>
          <SplitHeroTextCol>
            <SectionSubtitle style={{ color: '#1f2937' }}>Who We Are</SectionSubtitle>
            <SectionTitle>About Us</SectionTitle>
            <SectionDescription style={{ color: '#4b5563', marginBottom: 0 }}>
              Playfair started with a simple idea: managing team fines shouldn't be
              harder than managing the team itself.
            </SectionDescription>
          </SplitHeroTextCol>

          <SplitHeroMediaCol>
            <SplitHeroMedia autoPlay muted loop playsInline>
              <source src="/football.mp4" type="video/mp4" />
            </SplitHeroMedia>
            <FloatingBadge
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <FloatingBadgeNumber>200+</FloatingBadgeNumber>
              <FloatingBadgeLabel>Clubs Onboard</FloatingBadgeLabel>
            </FloatingBadge>
          </SplitHeroMediaCol>
        </SplitHeroGrid>
      </SplitHeroSection>

      <Section backgroundColor="#f0efea">
        <SectionContent>
          <PullQuoteWrap>
            <PullQuoteMark>&ldquo;</PullQuoteMark>
            <PullQuoteText>
              We were tired of spreadsheets and cash envelopes — so we built the tool
              we wished we'd had.
            </PullQuoteText>
            <PullQuoteAuthor>— The Playfair Team</PullQuoteAuthor>
          </PullQuoteWrap>
        </SectionContent>
      </Section>

      <Section backgroundColor="#000">
        <SectionContent>
          <StatsRow>
            {stats.map((stat) => (
              <StatItem key={stat.label}>
                <StatNumber>{stat.number}</StatNumber>
                <StatLabel>{stat.label}</StatLabel>
              </StatItem>
            ))}
          </StatsRow>
        </SectionContent>
      </Section>

      <Section backgroundColor="#fff">
        <SectionContent>
          <WhyPlayfair>
            {values.map((item) => (
              <WhyItem key={item.title} whileHover={{ y: -5 }}>
                <WhyIcon>{item.emoji}</WhyIcon>
                <WhyTitle>{item.title}</WhyTitle>
                <WhyText>{item.text}</WhyText>
              </WhyItem>
            ))}
          </WhyPlayfair>
        </SectionContent>
      </Section>
    </>
  );
}

export default AboutPage;
